'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = require('../../lib/ModalBody');

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'modalBody': 'Default__modalBody___2EzQf'
};

var DefaultModalBody = (0, _mergeThemeHoc2.default)(style)(_ModalBody2.default);
DefaultModalBody.displayName = 'DefaultModalBody';
exports.default = DefaultModalBody;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/ModalBody/index.js
// module id = 849
// module chunks = 4 5 8 9 14